import axios from 'axios';
import { baseUrl } from '../utils/constants';

export const getJobSubmissions = async (jobId = None, page= 1, pageSize = 10, order = null) => {
    let url = `${baseUrl()}r/submissions/${jobId}/job/?page=${page}&pageSize=${pageSize}`
    if (order && order != '') url += `${url}&ordering=${order}`
    return axios.get(url, { withCredentials: true })
};
